// @flow
import React from 'react'
import OptimizedImage from 'components/atoms/OptimizedImage'
import { imageURLWithTransform } from 'frontend_core/dist/helpers/format'

export type PropTypes = {
  uid: string,
  title: string,
  image: string,
  themeColor: string,
  link: string,
}

export default class TopicItemCard extends React.Component<*> {
  props: PropTypes
  render() {
    const imageUrl = imageURLWithTransform(this.props.image, {
      width: 670,
      height: 400,
      crop: 'fill',
    })
    return (
      <div className="col-sm-12 col-md-4 campaign-box">
        <a href={this.props.link}>
          <div className="campaign-linkbox is-hover">
            <div className="md-low-units md-campaign-units mdc-elevation--z2">
              <OptimizedImage src={imageUrl} alt={this.props.title} />
              <h3
                className="campaign-subtitle"
                style={{ backgroundColor: this.props.themeColor }}
              >
                <span className="campaign-subtitle__name">
                  {this.props.title}
                </span>
              </h3>
            </div>
          </div>
        </a>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/molecules/TopicListItem/index.jsx